export var DEAL_STATUS_CONFIGS = 'dealStatusConfigs';
export var DEAL_STATUS_TABLE_IDS = {
  STATUS: 'dealStatus',
  STATUS_KEY: 'dealStatusKey',
  DISPLAY_NAME: 'displayName',
  ENABLED: 'enabled'
};